import { $ } from './../helpers/query'
import Swiper from './../imports/import-swiper'
import BuildingModal from './BuildingModal'

export default class {
  constructor() {
    // attributes
    this.modalsAttr = 'data-modal';
    this.openModalAttr = 'data-open-modal';
    this.closeModalAttr = 'data-modal-close';
    this.openGalleryAttr = 'data-open-gallery';
    // classes
    this.openModalClass = 'modal--open';
    // elements
    this.modals = $(`[${this.modalsAttr}]`);
    this.openModalBtns = $(`[${this.openModalAttr}]`);
    this.closeModalBtns = $(`[${this.closeModalAttr}]`);
    this.openGalleryBtns = $(`[${this.openGalleryAttr}]`);
    this.galleryContSel = '.modal-gallery__carousel';
    // extra
    this.eventOpenModal = new Event('modalOpen');
    this.eventCloseModal = new Event('modalClose');
    this.initialSlide;
    this.buildingModal = new BuildingModal();
  }

  init() {
    // events
    this.openModal()
    this.closeModal()
    this.openGallery()
    this.buildingModal.openBuilding()
    this.buildingModal.plansToggle()
    this.buildingModal.spacePlansToggle()
    window.addEventListener('modalClose', () => {
      this.buildingModal.resetPlansToggle()
    })
  }

  openModal() {
    this.openModalBtns.on('click', (e, btn) => {
      let isOpen = false;
      this.modals.each((modal) => {
        if (modal.matches(`.${this.openModalClass}`)) isOpen = true;
      })

      const id = btn.getAttribute(this.openModalAttr);
      $(`[${this.modalsAttr}="${id}"]`).addClass(this.openModalClass);
      if (isOpen) $(`[${this.modalsAttr}="${id}"]`).css({ 'z-index':  6000});
      document.body.classList.add('no-scroll')

      setTimeout(() => {
        $(`[${this.modalsAttr}="${id}"]`).each((modal) => {
          this.open360View(modal)
        })
      }, 10)

      window.dispatchEvent(this.eventOpenModal)
    })
  }

  closeModal() {
    this.closeModalBtns.on('click', (e, btn) => {
      const modal = btn.closest(`[${this.modalsAttr}]`);
      modal.classList.remove(this.openModalClass)
      modal.style.zIndex = '';
      document.body.classList.remove('no-scroll')
      if (modal.querySelector('.modal-gallery')) this.closeVideo(modal);
      window.dispatchEvent(this.eventCloseModal)
    })
  }

  openGallery() {
    this.openGalleryBtns.on('click', (e, btn) => {
      const id = btn.getAttribute(this.openModalAttr);
      const carouselEl = document.querySelector(`[${this.modalsAttr}="${id}"] ${this.galleryContSel}`);
      this.initialSlide = 0;
      this.determineIndexOfSiblings(btn)
      this.initGalleryCarousel(carouselEl, this.initialSlide)
      this.openGalleryIframe(carouselEl)
    })
  }

  determineIndexOfSiblings(item) {
    this.initialSlide = this.initialSlide || 0;
    if (!item.previousElementSibling) {
      return;
    } else {
      ++this.initialSlide;
      this.determineIndexOfSiblings(item.previousElementSibling)
    }
  }

  initGalleryCarousel(container, initialSlide) {
    const wrapper = container.closest('.modal-gallery');
    const carousel = new Swiper(container, {
      initialSlide: initialSlide,
      speed: 700,
      navigation: {
        nextEl: wrapper.querySelector('.modal-gallery__next'),
        prevEl: wrapper.querySelector('.modal-gallery__prev'),
      },
      on: {
        slideChange: () => {
          this.closeVideo(container)
        },
        slideChangeTransitionEnd: () => {
          this.openGalleryIframe(container)
        }
      }
    })
  }

  open360View(modal) {
    const iframe = modal.querySelector('iframe.modal-fullscreen');
    this.initIframe(iframe)
  }

  openGalleryIframe(carouselEl) {
    const activeSlide = carouselEl.querySelector('.swiper-slide-active');
    const iframe = activeSlide.querySelector('iframe.modal-gallery__canvas, .modal-gallery__frame iframe');
    this.initIframe(iframe)
  }

  initIframe(iframe) {
    if (iframe && !iframe.hasAttribute('src')) {
      const src = iframe.getAttribute('data-src');
      iframe.setAttribute('src', src)
    }
  }

  closeVideo(modal) {
    const activeSlide = modal.querySelector('.swiper-slide-active');
    const activeFrame = activeSlide.querySelector('.modal-gallery__frame iframe');
    const activeVideo = activeSlide.querySelector('video');

    if (activeFrame) {
      const src = activeFrame.getAttribute('src');
      activeFrame.removeAttribute('src');
      activeFrame.setAttribute('data-src', src);
    }

    if (activeVideo) {
      activeVideo.pause()
    }
  }

}
